import { render } from "./SelectSkill.vue?vue&type=template&id=edee9b3c&scoped=true"
import script from "./SelectSkill.vue?vue&type=script&lang=js"
export * from "./SelectSkill.vue?vue&type=script&lang=js"

import "./SelectSkill.vue?vue&type=style&index=0&id=edee9b3c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edee9b3c"]])

export default __exports__